export default __webpack_public_path__ + "static/media/chuter.8d519f3d.png";